import { SvgIcon, SvgIconProps } from '@mui/material';

const PriorityIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.5 6.29848H10.8333C11.2754 6.29848 11.6993 6.47408 12.0118 6.78664C12.3244 7.0992 12.5 7.52312 12.5 7.96515V9.63182C12.5 10.0738 12.3244 10.4978 12.0118 10.8103C11.6993 11.1229 11.2754 11.2985 10.8333 11.2985H9.16667V14.6318H7.5V6.29848ZM9.16667 7.96515V9.63182H10.8333V7.96515H9.16667ZM4.16667 2.96515H15.8333C16.2754 2.96515 16.6993 3.14074 17.0118 3.4533C17.3244 3.76586 17.5 4.18979 17.5 4.63182V16.2985C17.5 16.7405 17.3244 17.1644 17.0118 17.477C16.6993 17.7896 16.2754 17.9651 15.8333 17.9651H4.16667C3.72464 17.9651 3.30072 17.7896 2.98816 17.477C2.67559 17.1644 2.5 16.7405 2.5 16.2985V4.63182C2.5 4.18979 2.67559 3.76586 2.98816 3.4533C3.30072 3.14074 3.72464 2.96515 4.16667 2.96515ZM4.16667 4.63182V16.2985H15.8333V4.63182H4.16667Z"
          fill="var(--mui-palette-text-secondary)"
        />
      </svg>
    </SvgIcon>
  );
};
export default PriorityIcon;
